<template>
  <div id="user" class="pa-4 pl-0">
    <!-- <v-container fluid> -->

    <div class="d-flex justify-space-between mb-5">
      <h2>사용자 관리</h2>
      <div class="right">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn @click="dialog = true" class="mr-4 white" icon v-on="{ ...tooltip }"><v-icon size="25"
                class="small">mdi-upload</v-icon></v-btn>
          </template>
          <span>사용자 업로드</span>
        </v-tooltip>
      </div>
    </div>

    <template>
      <v-card flat>
        <v-card-title>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="검색" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table no-data-text="사용자가 없습니다." v-model="selectedUsers" show-select :headers="headers" :items="users"
          :search="search" :loading="loading" loading-text="Loading... Please wait">
          <template v-slot:top>
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialogNew = true" color="primary">
                <v-icon size="25" class="small">mdi-plus</v-icon>
              </v-btn>
              <v-btn icon @click="deleteClick" color="red">
                <v-icon size="25" class="small">mdi-minus</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <!-- </v-row> -->
    <!-- </v-container> -->
    <v-snackbar v-model="snackbar">
      {{ snackbarTitle }}
      <v-btn color="white" text @click="snackbar = false" icon>
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>

    <upload-user-modal :open-dialog="dialog" v-on:closeDialog="closeDialog" />

    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          사용자 삭제
        </v-card-title>
        <v-card-text>선택된 사용자를 삭제할까요?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="deleteUsers">
            삭제
          </v-btn>
          <v-btn color="green darken-1" text @click="dialogDelete = false">
            취소
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNew"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">사용자 등록</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="사번*"
                  required
                  v-model="user.empno"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="이름"
                  required
                  v-model="user.name"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="부서/팀*"
                  required
                  v-model="user.department"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="이메일*"
                  required
                  v-model="user.email"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="직책*"
                  required
                  hint="사원,대리,과장,차장,부장,이사,상무,전무,사장"
                  v-model="user.position"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <small v-bind:style="{ color: error ? 'red' : ''}">* 필수 입력 사항입니다.</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="newUser"
          >
            추가
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="dialogNew = false"
          >
            취소
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadUserModal from '@/components/UploadUserModal'

import UserService from "@/services/UserService";
import moment from "moment";
export default {
  data: () => ({
    dialog: false,
    dialogNew: false,
    dialogDelete: false,
    loading: false,
    deleteBtnLoading: false,
    snackbar: false,
    snackbarTitle: '',
    tab: null,
    search: "",
    selectedUsers: [],
    url: process.env.VUE_APP_URL,
    headers: [
      {
        text: "이름",
        align: "start",
        value: "name",
      },
      { text: "이메일", value: "email" },
      { text: "사번", value: "empno" },
      // { text: "Actions", value: "actions", sortable: false },
    ],
    streams: [],
    itemToDelete: {},
    users: [],
    user: {
      empno: '',
      name: '',
      department: '',
      email: '',
      position: '',
    },
    error: null
  }),
  methods: {
    async getUsers() {
      this.loading = true;
      // const params = {};

      const users = await UserService.getAll("", { limit: 300 })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));

      if (!users) return;
      // console.log(videos)
      this.users = users.data.data;
    },
    // editItem(item) {
    //   this.$router.push({ name: `Detail`, params: { id: item.id } });
    // },
    // deleteBtn(item) {
    //   this.dialogDelete = true;
    //   this.itemToDelete = item;
    // },
    // async deleteItem() {
    //   this.deleteBtnLoading = true;
    //   await VideoService.deleteById(this.itemToDelete._id)
    //     .catch((err) => console.log(err))
    //     .finally(() => {
    //       this.videos = this.videos.filter(
    //         (video) => this.itemToDelete.id !== video.id
    //       );
    //       this.deleteBtnLoading = false;
    //       this.dialogDelete = false;
    //       this.itemToDelete = {};
    //       this.snackbar = true;
    //     });
    // },
    dateFormatter(date) {
      return moment(date).fromNow();
    },
    async newUser() {
      console.log(this.user)
      for (const [key, value] of Object.entries(this.user)) {
        console.log(value)
        if (value.trim() === '') {
          this.error = `필수 입력값 ${key} 을 모두 입력하세요.`
          return;
        }
      }

      this.user.channelName = this.user.email
      await UserService.createUser(this.user)
        .then(() => {
          this.user = {
            empno: '',
            name: '',
            department: '',
            email: '',
            position: '',
          }
          this.dialogNew = false
          this.getUsers()
        })
        .catch((err) => {
          this.snackbar = true
          this.snackbarTitle = err.response.data.error
          console.log(err.response.data)
          console.log(err)
        })
    },
    async deleteUsers() {
      await UserService.deleteByUsers(this.selectedUsers.map(user => { return user.id }))
        .catch((err) => console.log(err))
        .finally(() => {
          this.selectedUsers = []
          this.dialogDelete = false
          this.getUsers()
        });
    },
    closeDialog() {
      this.dialog = false;
      this.getUsers();
    },
    deleteClick() {
      if (this.selectedUsers.length < 1) {
        this.snackbarTitle = '선택된 사용자가 없습니다.'
        this.snackbar = true
        return;
      }
      this.dialogDelete = true;
    }
  },
  mounted() {
    this.getUsers();
  },
  beforeRouteUpdate(to, from, next) {
    this.getUsers();
    next();
  },
  components: {
    UploadUserModal,
  },
};
</script>

<style lang="scss">
// .card,
// #tab .v-tabs-bar {
//   background: #f9f9f9 !important;
// }
</style>
